'use client';
import { CompletedMatch } from '@/modules/league/new-components/types';

interface ScoreBoxProps {
  player: CompletedMatch;
  indexOfPlayer: number;
  teamNumber: number;
  scoresArray: {
    team1Score: number;
    team2Score: number;
  }[];
  setScoresArray: React.Dispatch<
    React.SetStateAction<
      {
        team1Score: number;
        team2Score: number;
      }[]
    >
  >;
  isAuthorized: boolean | null;
}

export const ScoreBox = ({
  player,
  indexOfPlayer,
  teamNumber,
  scoresArray,
  setScoresArray,
  isAuthorized,
}: ScoreBoxProps) => {
  const scoreValueGroup1 = scoresArray[indexOfPlayer]?.team1Score;
  const scoreValueGroup2 = scoresArray[indexOfPlayer]?.team2Score;

  const placeholderGroup1 = String(scoreValueGroup1 || '0');
  const placeholderGroup2 = String(scoreValueGroup2 || '0');

  return (
    <input
      className='flex h-[40px] w-[48px] cursor-pointer items-center justify-center rounded-md border text-center [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
      min={0}
      max={99}
      type='number'
      inputMode='numeric'
      pattern='^\d+$'
      {...{
        name: teamNumber === 1 ? player?.T1a_FirstName : player?.T2a_FirstName,
        id: teamNumber === 1 ? player?.T1a_UserID : player?.T2a_UserID,
        value: teamNumber === 1 ? scoreValueGroup1 : scoreValueGroup2,
        placeholder: teamNumber === 1 ? placeholderGroup1 : placeholderGroup2,
      }}
      onChange={(e) => {
        const value = e.target.value.slice(0, 2);
        const updatedScoresArray = scoresArray.map((score, index) =>
          index === indexOfPlayer
            ? { ...score, [`team${teamNumber}Score`]: parseInt(value) || 0 }
            : score
        );
        setScoresArray(updatedScoresArray);
      }}
      disabled={!isAuthorized}
    />
  );
};
